import blog1 from "../assets/images/blog/berita1.png";
import blog2 from "../assets/images/blog/berita2.png";
import blog3 from "../assets/images/blog/berita3.png";

export const blogData = [
  {
    id: 1,
    image: blog1,
    title: "Penjehat Perang, Indonesia Dukung Penangkapan Netanyahu dan Gallant sesuai Keputusan ICC",

    date: "Nov 26, 2024",
  },
  {
    id: 2,
    image: blog2,
    title: "Genosida di Gaza Belum Berakhir Dilaporkan 1.000 Lebih Tenaga Medis Meninggal Dunia",

    date: "Nov 26, 2024",
  },
  {
    id: 3,
    image: blog3,
    title: "Palestina kecam veto AS atas resolusi gencatan senjata Gaza di PBB",
    date: "Nov 21, 2024",
  },
];
